export default __webpack_public_path__ + "static/cloudhunters-74f7337dd9c98d389652c97407b72fc4.mp4";